

import React, { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, Collapse, Container } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
// Company
import CompanyIndex from './components/pages/company/Index';
import CompanyCreate from "./components/pages/company/Create";
import CompanyEdit from "./components/pages/company/Edit";
// Branch
import BranchIndex from './components/pages/branch/Index';
import BranchCreate from "./components/pages/branch/Create";
import BranchEdit from "./components/pages/branch/Edit";
// Category
import CategoryIndex from './components/pages/category/Index';
import CategoryCreate from "./components/pages/category/Create";
import CategoryEdit from "./components/pages/category/Edit";
// PGCategory
import PGCategoryIndex from './components/pages/pgcategory/Index';
import PGCategoryCreate from "./components/pages/pgcategory/Create";
import PGCategoryEdit from "./components/pages/pgcategory/Edit";
// Item Group
import ItemGroupIndex from './components/pages/itemgroup/Index';
import ItemGroupCreate from "./components/pages/itemgroup/Create";
import ItemGroupEdit from "./components/pages/itemgroup/Edit";
// Item 
import ItemIndex from './components/pages/item/Index';
import ItemCreate from "./components/pages/item/Create";
import ItemEdit from "./components/pages/item/Edit";
//User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";
//Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";
//SalesMan
import SalesManCreate from "./components/pages/SalesMan/Create";
import SalesManIndex from "./components/pages/SalesMan/Index";
import SalesManEdit from "./components/pages/SalesMan/Edit";
//Purchase
import PurchaseIndex from "./components/pages/purchase/Index";
import PurchaseCreate from "./components/pages/purchase/Create";
import PurchaseEdit from "./components/pages/purchase/Edit";
import PurchaseDetails from "./components/pages/purchase/Details";
//PurchaseReturn
import PurchaseReturnIndex from "./components/pages/purchasereturn/Index";
import PurchaseReturnCreate from "./components/pages/purchasereturn/Create";
import PurchaseReturnEdit from "./components/pages/purchasereturn/Edit";
import PurchaseReturnDetails from "./components/pages/purchasereturn/Details";
//Sale
import SaleIndex from "./components/pages/sale/Index";
import SaleCreate from "./components/pages/sale/Create";
import SaleEdit from "./components/pages/sale/Edit";
import SaleDetails from "./components/pages/sale/Details";
//Sale Return
import SaleReturnIndex from "./components/pages/salereturn/Index";
import SaleReturnCreate from "./components/pages/salereturn/Create";
import SaleReturnEdit from "./components/pages/salereturn/Edit";
import SaleReturnDetails from "./components/pages/salereturn/Details";
//Stock Transfer
import StockTransferIndex from "./components/pages/stocktransfer/Index";
import StockTransferCreate from "./components/pages/stocktransfer/Create";
import StockTransferEdit from "./components/pages/stocktransfer/Edit";
import StockIn from "./components/pages/stocktransfer/StockIn";
import StockInDetail from "./components/pages/stocktransfer/StockInDetail";
import StockTransferDetails from "./components/pages/stocktransfer/Details";
import StockInCreate from "./components/pages/stocktransfer/StockInCreate";
import StockTransferEcommCreate from "./components/pages/stocktransfer/EcommCreate";
import StockInPending from "./components/pages/stocktransfer/StockInPending";

// Replacement
import ReplacementIndex from "./components/pages/replacement/Index";
import ReplacementCreate from "./components/pages/replacement/Create";
import ReplacementEdit from "./components/pages/replacement/Edit";
import ReplacementDetails from "./components/pages/replacement/Details";
// Report
import DailySalesSummary from "./components/pages/Report/DailySalesSummary";
import Stock from "./components/pages/Report/Stock";
import StockTransfer from "./components/pages/Report/StockTransfer";
import CutomerDetails from "./components/pages/Report/CustomerDetails";
import PurchaseSummary from "./components/pages/Report/PurchaseSummary";
import DailySalesPaymentWise from "./components/pages/Report/DailySalesPaymentWise";
import KPIReport from "./components/pages/Report/KPIReport";
import BestSellerSales from "./components/pages/Report/BestSellerSales";
import RepairORReplacement from "./components/pages/Report/RepairORReplacement";
import StockTransferIn from "./components/pages/Report/StockTransferIn";
import StockTransferOut from "./components/pages/Report/StockTransferOut"
// OtherReport
import OtherDailySalesSummary from "./components/pages/otherbranch/OtherDailySalesSummary";
import OtherPurchaseSummary from "./components/pages/otherbranch/OtherPurchaseSummary";
import OtherStock from "./components/pages/otherbranch/OtherStock";
import AjioStock from "./components/pages/otherbranch/AjioStock";
import OtherStockTransfer from "./components/pages/otherbranch/OtherStockTransfer";
import OtherDSSPaymentWise from "./components/pages/otherbranch/OtherDSSPaymentWise";
import OtherKPIReport from "./components/pages/otherbranch/OtherKPIReport";
import OtherRepairORReplacement from "./components/pages/otherbranch/OtherRepairORReplacement";
import OtherCustomerDetails from "./components/pages/otherbranch/OtherCustomerDetails";
import OtherStockTransferIn from "./components/pages/otherbranch/OtherStockTransferIn"
import OtherStockTransferOut from "./components/pages/otherbranch/OtherStockTransferOut"
//repairandreplacement
import RepairAndReplacementIndex from "./components/pages/repairandreplacement/Index";
import RepairAndReplacementCreate from "./components/pages/repairandreplacement/Create";
import RepairAndReplacementDetails from "./components/pages/repairandreplacement/Details";
import RepairAndReplacementEdit from "./components/pages/repairandreplacement/Edit";

import Home from "./components/pages/Home";
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import './components/pages/HomeEnhanced.css';
import LodingComponent from "./loding";
import { AuthProvider, useAuth } from "./AuthContext";
import Logout from "./Logout";
import SessionTimeout from "./SessionTimeout";

import InventoryIcon from '@mui/icons-material/Inventory';
import PaymentsIcon from '@mui/icons-material/Payments';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentIcon from '@mui/icons-material/Payment';
import WalletIcon from '@mui/icons-material/Wallet';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LabelIcon from '@mui/icons-material/Label';

import StoreIcon from '@mui/icons-material/Store';
import CategoryIcon from '@mui/icons-material/Category';
import PersonIcon from '@mui/icons-material/Person';
import Person2Icon from '@mui/icons-material/Person2';
import ContactsIcon from '@mui/icons-material/Contacts';
import ListAltIcon from '@mui/icons-material/ListAlt';
import GroupWorkIcon from '@mui/icons-material/GroupWork';

import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ArticleIcon from '@mui/icons-material/Article';

import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import BuildIcon from '@mui/icons-material/Build';

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [otherOpen, setOtherOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };

  const handleOtherClick = () => {
    setOtherOpen(!otherOpen);
  };


  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };

  const handleItemClick = () => {
    setItemOpen(!itemOpen);
  };

  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName, branchId } = useAuth();

  return (
    <Router>
      <AuthProvider>
        <SessionTimeout />
        {/* ── Top Bar ─────────────────────────────────────────── */}
        <header className="app-topbar">
          <button className="app-topbar-menu-btn" aria-label="Open menu" onClick={handleDrawerOpen}>
            <MenuIcon fontSize="small" />
          </button>
          <Link to="/Home" className="app-topbar-brand">
            <span className="app-topbar-home-icon"><FiHome size={16} /></span>
            <span className="app-topbar-title">{companyName}</span>
          </Link>
          <div className="app-topbar-actions">
            <Logout />
          </div>
        </header>
        {roleName !== "Counter" && (
          <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}
            PaperProps={{ className: 'app-drawer-paper' }}>
            <div className="app-drawer-header">
              <div className="app-drawer-brand">{companyName}</div>
            </div>
            <List disablePadding>
              <ListItem button component={NavLink} to="/Home" activeClassName="selected"
                className="app-nav-item" onClick={handleDrawerClose}>
                <ListItemText primary="Home" />
              </ListItem>

              {roleName != "Accounts" && (
                <ListItem button className="app-nav-section" onClick={handleMasterClick}>
                  <ListItemText primary="Master" />
                  {masterOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
              )}

              <Collapse in={masterOpen} timeout="auto" unmountOnExit>
                <List disablePadding style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/BranchIndex" activeClassName="selected"
                    className="app-nav-item" onClick={handleDrawerClose}>
                    <StoreIcon style={{ color: 'blueviolet', fontSize: 16, marginRight: 6 }} /><ListItemText primary="Branch" />
                  </ListItem>

                  {roleName == "SuperAdmin" && (
                    <ListItem button component={NavLink} to="/CategoryIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                      <CategoryIcon style={{ color: 'darkcyan', height: '20px' }} /><ListItemText primary="Category" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}

                  {roleName == "SuperAdmin" && (
                    <ListItem button component={NavLink} to="/PGCategoryIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                      <CategoryIcon style={{ color: 'darkseagreen', height: '20px' }} /><ListItemText primary="PG Category" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}

                  {roleName == "SuperAdmin" && (
                    <ListItem button component={NavLink} to="/ItemGroupIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                      <GroupWorkIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Item Group" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}

                  <ListItem button component={NavLink} to="/ItemIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <LabelIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Item" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/SalesManIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <ContactsIcon style={{ color: 'red', height: '20px' }} /><ListItemText primary="Sales Man" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  {(roleName == "SuperAdmin" || roleName == "CompanyAdmin") && (
                    <ListItem button component={NavLink} to={`/companyEdit/${companyId}`} activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                      <CategoryIcon style={{ color: 'darkcyan', height: '20px' }} /><ListItemText primary="Promo Settings" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}

                </List>
              </Collapse>

              {roleName != "Accounts" && (
                <ListItem button className="app-nav-section" onClick={handleItemClick}>
                  <ListItemText primary="Transaction" />
                  {itemOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
              )}

              <Collapse in={itemOpen} timeout="auto" unmountOnExit>
                <List disablePadding style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/PurchaseIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <InventoryIcon style={{ color: 'green', height: '20px' }} /><ListItemText primary="Purchase" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/PurchaseReturnIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <AssignmentReturnIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="Purchase Return" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/SaleIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <AddShoppingCartIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Sale" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/SaleReturnIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <RemoveShoppingCartIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Sale Return" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/StockTransferIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <MoveUpIcon style={{ color: 'darkcyan', height: '20px' }} /><ListItemText primary="Stock Out" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/StockIn" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <MoveDownIcon style={{ color: 'darkgreen', height: '20px' }} /><ListItemText primary="Stock In" style={{ marginLeft: '3px' }} />
                  </ListItem>
                  <ListItem button component={NavLink} to="/RepairAndReplacementIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <BuildIcon style={{ color: 'red', height: '20px' }} /><ListItemText primary="Repair / Replacement" style={{ marginLeft: '3px' }} />
                  </ListItem>

                </List>
              </Collapse>

              {roleName != "Accounts" && (
                <ListItem button className="app-nav-section" onClick={handleReportClick}>
                  <ListItemText primary="Report" />
                  {reportOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
              )}

              <Collapse in={reportOpen} timeout="auto" unmountOnExit>
                <List disablePadding style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/DailySalesSummary" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <InventoryIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="DSS" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/DailySalesPaymentWise" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <PaymentsIcon style={{ color: 'darkseagreen', height: '20px' }} /><ListItemText primary="DSS Payment Wise" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/KPIReport" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <ArticleIcon style={{ color: 'red', height: '20px' }} /><ListItemText primary="KPI Report" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/RepairORReplacement" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <BuildIcon style={{ color: '#B03052', height: '20px' }} /><ListItemText primary="Repair / Replacement" style={{ marginLeft: '3px' }} />
                  </ListItem>


                  <ListItem button component={NavLink} to="/BestSellerSales" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <LibraryBooksIcon style={{ color: 'green', height: '20px' }} /><ListItemText primary="Best Seller Sales" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/Stock" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <SummarizeIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Consolidated Stock" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/PurchaseSummary" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <LibraryBooksIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Purchase Summary" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/StockTransferIn" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <MoveDownIcon style={{ color: 'darkgreen', height: '20px' }} /><ListItemText primary="Stock Transfer IN" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/StockTransferOut" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <MoveUpIcon style={{ color: '#9d30b0ff', height: '20px' }} /><ListItemText primary="Stock Transfer Out" style={{ marginLeft: '3px' }} />
                  </ListItem>


                  <ListItem button component={NavLink} to="/CutomerDetails" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <PersonIcon style={{ color: 'darkcyan', height: '20px' }} /><ListItemText primary="Customer Data" style={{ marginLeft: '3px' }} />
                  </ListItem>


                </List>
              </Collapse>

              {(roleName == "Accounts" || roleName == "SuperAdmin" || companyId == '1009') && (
                <ListItem button className="app-nav-section" onClick={handleOtherClick}>
                  <ListItemText primary="Branch Report" />
                  {otherOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
              )}

              <Collapse in={otherOpen} timeout="auto" unmountOnExit>
                <List disablePadding style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/OtherDailySalesSummary" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <InventoryIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="DSS" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherDSSPaymentWise" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <PaymentsIcon style={{ color: 'darkseagreen', height: '20px' }} /><ListItemText primary="DSS Payment Wise" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherKPIReport" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <ArticleIcon style={{ color: 'red', height: '20px' }} /><ListItemText primary="KPI Report" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherRepairORReplacement" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <BuildIcon style={{ color: '#B03052', height: '20px' }} /><ListItemText primary="Repair / Replacement" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/BestSellerSales" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <LibraryBooksIcon style={{ color: 'green', height: '20px' }} /><ListItemText primary="Best Seller Sales" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherStock" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <SummarizeIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Consolidated Stock" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherPurchaseSummary" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <LibraryBooksIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Purchase Summary" style={{ marginLeft: '3px' }} />
                  </ListItem>
                  {(roleName != "Accounts") && (
                    <ListItem button component={NavLink} to="/AjioStock" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                      <ListAltIcon style={{ color: 'darkcyan', height: '20px' }} /><ListItemText primary="AJIO Stock" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}
                  {/* <ListItem button component={NavLink} to="/OtherStockTransfer" activeClassName="selected" onClick={handleDrawerClose}>
                    <ArticleIcon style={{ color: 'darkgreen', height: '20px' }} /><ListItemText primary="Stock Transfer" style={{ marginLeft: '3px' }} />
                  </ListItem> */}

                  <ListItem button component={NavLink} to="/OtherStockTransferIn" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <MoveDownIcon style={{ color: 'darkgreen', height: '20px' }} /><ListItemText primary="Stock Transfer IN" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherStockTransferOut" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <MoveUpIcon style={{ color: '#9d30b0ff', height: '20px' }} /><ListItemText primary="Stock Transfer Out" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherCustomerDetails" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <PersonIcon style={{ color: 'darkcyan', height: '20px' }} /><ListItemText primary="Customer Data" style={{ marginLeft: '3px' }} />
                  </ListItem>

                </List>
              </Collapse>

              <ListItem button className="app-nav-section" onClick={handleUserClick}>
                <ListItemText primary="User" />
                {userOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>

              <Collapse in={userOpen} timeout="auto" unmountOnExit>
                <List disablePadding style={{ paddingLeft: '16px' }}>

                  {roleName == "SuperAdmin" && (

                    <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                      <PeopleAltIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="User" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}

                  {roleName == "SuperAdmin" && (
                    <ListItem button component={NavLink} to="/RoleIndex" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                      <AccessibilityIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Role" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}

                  <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" className="app-nav-item" onClick={handleDrawerClose}>
                    <SecurityIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Change Password" style={{ marginLeft: '3px' }} />
                  </ListItem>
                </List>
              </Collapse>

            </List>
          </Drawer>
        )}

        <Container maxWidth="xl">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/Home" exact component={Home} />
            {/* Company */}
            <Route path="/CompanyIndex" component={CompanyIndex} />
            <Route path="/CompanyCreate" component={CompanyCreate} />
            <Route path="/CompanyEdit/:id" component={CompanyEdit} />
            {/* Branch */}
            <Route path="/BranchIndex" component={BranchIndex} />
            <Route path="/BranchCreate" component={BranchCreate} />
            <Route path="/BranchEdit/:id" component={BranchEdit} />
            {/* Category */}
            <Route path="/CategoryIndex" component={CategoryIndex} />
            <Route path="/CategoryCreate" component={CategoryCreate} />
            <Route path="/CategoryEdit/:id" component={CategoryEdit} />
            {/* PGCategory */}
            <Route path="/PGCategoryIndex" component={PGCategoryIndex} />
            <Route path="/PGCategoryCreate" component={PGCategoryCreate} />
            <Route path="/PGCategoryEdit/:id" component={PGCategoryEdit} />
            {/* ItemGroup */}
            <Route path="/ItemGroupIndex" component={ItemGroupIndex} />
            <Route path="/ItemGroupCreate" component={ItemGroupCreate} />
            <Route path="/ItemGroupEdit/:id" component={ItemGroupEdit} />
            {/* Item */}
            <Route path="/ItemIndex" component={ItemIndex} />
            <Route path="/ItemCreate" component={ItemCreate} />
            <Route path="/ItemEdit/:id" component={ItemEdit} />
            {/* User */}
            <Route path="/UserIndex" component={UserIndex} />
            <Route path="/UserCreate" component={UserCreate} />
            <Route path="/UserEdit/:id" component={UserEdit} />
            <Route path="/UserDetail/:id" component={UserDetail} />
            <Route path="/PasswordChange" component={PasswordChange} />
            {/* Role */}
            <Route path="/RoleIndex" component={RoleIndex} />
            <Route path="/RoleDetail/:id" component={RoleDetail} />
            {/* SalesMan */}
            <Route path="/SalesManIndex" component={SalesManIndex} />
            <Route path="/SalesManCreate" component={SalesManCreate} />
            <Route path="/SalesManEdit/:id" component={SalesManEdit} />
            {/* Purchase */}
            <Route path="/PurchaseIndex" component={PurchaseIndex} />
            <Route path="/PurchaseCreate" component={PurchaseCreate} />
            <Route path="/PurchaseEdit/:id" component={PurchaseEdit} />
            <Route path="/PurchaseDetails/:id" component={PurchaseDetails} />
            {/* Purchase Return*/}
            <Route path="/PurchaseReturnIndex" component={PurchaseReturnIndex} />
            <Route path="/PurchaseReturnCreate" component={PurchaseReturnCreate} />
            <Route path="/PurchaseReturnEdit/:id" component={PurchaseReturnEdit} />
            <Route path="/PurchaseReturnDetails/:id" component={PurchaseReturnDetails} />
            {/* Sale */}
            <Route path="/SaleIndex" component={SaleIndex} />
            <Route path="/SaleCreate" component={SaleCreate} />
            <Route path="/SaleEdit/:id" component={SaleEdit} />
            <Route path="/SaleDetails/:id" component={SaleDetails} />
            {/* Sale Return*/}
            <Route path="/SaleReturnIndex" component={SaleReturnIndex} />
            <Route path="/SaleReturnCreate" component={SaleReturnCreate} />
            <Route path="/SaleReturnEdit/:id" component={SaleReturnEdit} />
            <Route path="/SaleReturnDetails/:id" component={SaleReturnDetails} />
            {/* Stock Transfer*/}
            <Route path="/StockTransferIndex" component={StockTransferIndex} />
            <Route path="/StockTransferCreate" component={StockTransferCreate} />
            <Route path="/StockTransferEdit/:id" component={StockTransferEdit} />
            <Route path="/StockIn" component={StockIn} />
            <Route path="/StockInDetail/:id" component={StockInDetail} />
            <Route path="/StockTransferDetails/:id" component={StockTransferDetails} />
            <Route path="/StockInCreate" component={StockInCreate} />
            <Route path="/StockTransferEcommCreate" component={StockTransferEcommCreate} />
            <Route path="/StockInPending/:id" component={StockInPending} />
            {/* Replacement*/}
            <Route path="/ReplacementIndex" component={ReplacementIndex} />
            <Route path="/ReplacementCreate" component={ReplacementCreate} />
            <Route path="/ReplacementEdit/:id" component={ReplacementEdit} />
            <Route path="/ReplacementDetails/:id" component={ReplacementDetails} />
            {/* Report*/}
            <Route path="/DailySalesSummary" component={DailySalesSummary} />
            <Route path="/Stock" component={Stock} />
            <Route path="/StockTransfer" component={StockTransfer} />
            <Route path="/CutomerDetails" component={CutomerDetails} />
            <Route path="/PurchaseSummary" component={PurchaseSummary} />
            <Route path="/DailySalesPaymentWise" component={DailySalesPaymentWise} />
            <Route path="/KPIReport" component={KPIReport} />
            <Route path="/BestSellerSales" component={BestSellerSales} />
            <Route path="/RepairORReplacement" component={RepairORReplacement} />
            <Route path="/StockTransferIn" component={StockTransferIn} />
            <Route path="/StockTransferOut" component={StockTransferOut} />
            {/* Other Report*/}
            <Route path="/OtherDailySalesSummary" component={OtherDailySalesSummary} />
            <Route path="/OtherPurchaseSummary" component={OtherPurchaseSummary} />
            <Route path="/OtherStock" component={OtherStock} />
            <Route path="/AjioStock" component={AjioStock} />
            <Route path="/OtherStockTransfer" component={OtherStockTransfer} />
            <Route path="/OtherDSSPaymentWise" component={OtherDSSPaymentWise} />
            <Route path="/OtherKPIReport" component={OtherKPIReport} />
            <Route path="/OtherRepairORReplacement" component={OtherRepairORReplacement} />
            <Route path="/OtherCustomerDetails" component={OtherCustomerDetails} />
            <Route path="/OtherStockTransferIn" component={OtherStockTransferIn} />
            <Route path="/OtherStockTransferOut" component={OtherStockTransferOut} />
            {/* RepairAndReplacement*/}
            <Route path="/RepairAndReplacementIndex" component={RepairAndReplacementIndex} />
            <Route path="/RepairAndReplacementCreate" component={RepairAndReplacementCreate} />
            <Route path="/RepairAndReplacementDetails/:id" component={RepairAndReplacementDetails} />
            <Route path="/RepairAndReplacementEdit/:id" component={RepairAndReplacementEdit} />
          </Switch>
        </Container>


      </AuthProvider >
    </Router>
  );
};

export default App;

